export default __webpack_public_path__ + "images/onboarding/ladder-08e2e10bee1671a609eaec0ff7fee6bb.svg";